import styled from "styled-components";
import Select from "../../common/Select";
import { CashAccount, CashCategory, CashFlowType } from "../../../types/common.types";
import { mobile } from "../../../styles/responsive";

interface FilterInterface {
    accounts: CashAccount[]
    categories: CashCategory[]
    accountId: string
    setAccountId: (value: string) => void
    movementType: CashFlowType | ''
    setMovementType: (value: CashFlowType | '') => void
    categoryId: string
    setCategoryId: (value: string) => void
}

export default function Filter({
    accounts,
    categories,
    accountId,
    setAccountId,
    movementType,
    setMovementType,
    categoryId,
    setCategoryId
}: FilterInterface) {
    const filteredCategories = movementType ? categories.filter(c => c.flow_type === movementType) : categories

    return (
        <Main>
            <div className="dropdowns">
                <Select
                    options={[{ value: 'ingreso', name: 'Ingreso' }, { value: 'egreso', name: 'Egreso' }]}
                    defaultNull
                    value={movementType}
                    onChange={(e) => { setMovementType(e.target.value as CashFlowType | ''); setCategoryId('') }}
                />
                <Select
                    options={accounts.map(a => ({ value: a.id, name: a.name }))}
                    defaultNull
                    value={accountId}
                    onChange={(e) => setAccountId(e.target.value)}
                />
                <Select
                    options={filteredCategories.map(c => ({ value: c.id, name: c.name }))}
                    defaultNull
                    value={categoryId}
                    onChange={(e) => setCategoryId(e.target.value)}
                />
            </div>
        </Main>
    )
}

const Main = styled.div`
width: 100%;
padding: 20px 0;
display: flex;
flex-direction: column;
gap: 15px;
align-items: center;
.dropdowns {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
    ${mobile({
        flexDirection: 'column',
        width: '100%'
    })}
}
`
